import "./Contact.module.css";
import GlobalHeader from "@/reusable_sections/Header";
import InquiryGateway from "./sections/InquiryGateway";
import FundingRequestCenter from "./sections/FundingRequestCenter";
import OfficePresence from "./sections/OfficePresence";
import InstitutionalFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <GlobalHeader />
      <InquiryGateway />
      <FundingRequestCenter />
      <OfficePresence />
      <InstitutionalFooter />
    </div>;
}